// extracted by mini-css-extract-plugin
module.exports = {"skeletonBlock":"styles_skeletonBlock__2PRts","skeletonText":"styles_skeletonText__oYJY2"};